import { render, staticRenderFns } from "./TrademarkRenewalsList.vue?vue&type=template&id=eefaf19e&"
import script from "./TrademarkRenewalsList.vue?vue&type=script&lang=js&"
export * from "./TrademarkRenewalsList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkRenewalsList.vue?vue&type=style&index=0&id=eefaf19e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports